import { HistoryAction } from './history-action.enum';

export class HistoryModel {
    createdAt: number;

    constructor(
        public action: HistoryAction,
        public value: any
    ) {
        this.createdAt = new Date().valueOf();
    }
}
